import { Stack, Typography } from "@mui/material";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const OnboardingWelcome = () => {
	const { translate } = useLocales();
	return (
		<Stack
			alignItems={"center"}
			justifyContent={"center"}
			sx={{ backgroundColor: "text.primary", height: "100vh" }}
		>
			<Image src={"/ilustrations/light_bro.svg"} sx={{ height: 450 }} />
			<Typography variant='h3' color={"white"} sx={{ mt: 1 }}>
				{translate("¡Bienvenido a Finlink!")}
			</Typography>
			<Typography color='text.secondary' sx={{ mt: 1 }}>
				{translate("¡Gracias por confiar en nosotros!")}
			</Typography>
		</Stack>
	);
};

export default OnboardingWelcome;
